// the bridge uses jotai for state
// https://github.com/pmndrs/jotai

import {
  bridgeTokens,
  BridgeToken,
} from 'structure/bridge/constants/bridgeTokens';
import { atom } from 'jotai';
import { NetworkChainIds } from '@dapp/multi-lib/network';
import { bsc } from 'viem/chains';

const defaultDestinationNetwork = bsc.id; // default network is ethereum so we default destination to bsc

export interface BridgeAtom {
  token: BridgeToken;
  dstChainId: NetworkChainIds;
  amount: number;
  nativeFee: bigint;
  tokenFee: bigint;
  tokenQuoteLoading: boolean;
  userBalance: bigint;
}

export const bridgeAtom = atom<BridgeAtom>({
  token: bridgeTokens.filter((token) => token.enabled)[0],
  dstChainId: defaultDestinationNetwork,
  amount: 0,
  nativeFee: BigInt(0),
  tokenFee: BigInt(0),
  tokenQuoteLoading: false,
  userBalance: BigInt(0),
});
